export const formatFingerprint = fingerprint => {
	return fingerprint.replace(/(.{2})/g, '$1:').slice(0, -1);
};
